/** Hover help copy for Overview tab sections (shown only via section (i) tooltips). */

export const PERF_HUB_OVERVIEW_HELP = {
  campaignRoi:
    'Tie spend to reach and engagement. Compare tracked spend, cost per 1,000 reach, cost per engagement, and CPM. Set per-creator fees or a campaign budget under Edit spend.',

  creativeDna:
    'Content patterns from the top ~25% of synced posts by blended score (reach, saves, engagement, spend when set). Winner styles and correlations are based on that top-quartile pool for this campaign only.',

  commentIntelligence:
    'Comments are pulled when you refresh metrics. See buyer themes, top questions, sentiment (with spike alerts), and whether creators reply—then copy notes or save to CRM to follow up manually.',

  creatorIntelligence:
    'Per-creator scorecards from synced Instagram data—delivery, performance, efficiency, re-book and UGC signals, and trend vs the previous refresh. Filter, select rows, and add to your private CRM shortlist. Re-book: strong fit for a future campaign. Phase 2: recommended for a second wave. UGC: good candidate to reuse the post. Trend compares metrics to the prior refresh.',

  topPerformers:
    'All creators with synced Instagram metrics for this campaign (OAuth-connected or via public data). Sort by engagement, reach, saves, and more—export or shortlist standouts. Separate from the Creative DNA learnings panel above.',
};
